export default __webpack_public_path__ + "static/media/logo-dark.25b9161c.svg";